// extracted by mini-css-extract-plugin
export var arrowIcon = "styles-module--arrowIcon--UK3ts";
export var buttonContainer = "styles-module--buttonContainer--zfWHI";
export var buttonContainerRightAligned = "styles-module--buttonContainerRightAligned--iNGGs";
export var container = "styles-module--container--dbWlu";
export var content = "styles-module--content--F8GTi";
export var contentFlex = "styles-module--contentFlex--OAntH";
export var desktop = "1340px";
export var dockedBottom = "styles-module--dockedBottom--HNdjV";
export var dockedTop = "styles-module--dockedTop--I3tAE";
export var downloadIcon = "styles-module--downloadIcon--dy1IA";
export var flattenBottom = "styles-module--flattenBottom--VvhHi";
export var flattenTop = "styles-module--flattenTop--a4cDb";
export var giant = "2200px";
export var grid = "styles-module--grid--0Aupc";
export var header = "styles-module--header--8yBqQ";
export var headerHeading = "styles-module--headerHeading--EBm17";
export var headerStatus = "styles-module--headerStatus--cxgFT";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mailIcon = "styles-module--mailIcon--Pjxl8";
export var mobile = "400px";
export var padded = "styles-module--padded--LSi5x";
export var rawBody = "styles-module--rawBody--tpGQr";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";